<template>
  <TemplateLayout ref="layout" :stopScroll="stopScroll">
    <template v-slot:main>
      <!-- 描述图 -->
      <slot name="main"></slot>
      <!-- 协议通知 -->
      <Agreement
        v-if="isShowAgreement"
        :id="agreementId"
        class="agreement-text"
        :class="{ 'no-default-agree': !defaultAgreement }"
        :isShowSelect="isShowAgreementSelect"
        :isBlueStyle="isBlueStyle"
        :agreementTitles="agreementTitles"
        :agreementType="agreementType"
        :defaultAgreement="defaultAgreement"
        :defaultSelectStatus="defaultSelectStatus"
        @change="handleAgreementChange"
        @show-agreement="handleShowAgreement"
        @init-agreements="handleInitAgreements"
      ></Agreement>
    </template>
    <!-- 渠道选择 -->
    <slot slot="container-absolute-item" name="container-absolute-item"></slot>
    <!-- 报名按钮 -->
    <div slot="bottom" :class="{ 'ios-safe-bottom': !isShowBottomTip }">
      <slot name="bottom"></slot>
      <div v-if="isShowBottomTip" class="agree">
        {{ isShowAgreeTip ? agreementTip : bottomTip }}
      </div>
    </div>
    <div slot="fix-items">
      <slot name="fix-items"></slot>
    </div>
    <div slot="modal">
      <AgreementModal
        v-if="isShowModal"
        :res="renderItem"
        @closeHandle="isShowModal = false"
      ></AgreementModal>
    </div>
  </TemplateLayout>
</template>


<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import TemplateLayout from './TemplateLayout.vue';
import Agreement from './Agreement';
import AgreementModal from '@/components/enrolment-comp/agreement.vue';
import SmoothScroll from '@/lib/SmoothScroll';
@Component({
  components: {
    TemplateLayout,
    Agreement,
    AgreementModal,
  },
})
export default class TemplatePreset extends Vue {
  isShowAgreeTip = false;

  @Prop({ type: Boolean, default: false }) isBlueStyle!: boolean;
  @Prop({ type: String, default: '' }) agreementId!: string;
  @Prop({ type: Boolean, default: true }) isShowAgreementSelect!: boolean;
  @Prop({ type: Boolean, default: true }) isShowAgreement!: boolean;
  @Prop({ type: String, default: '请先同意以上协议' }) agreementTip!: string;
  @Prop({ type: String }) bottomTip!: string;
  @Prop({ type: Array }) agreementTitles!: string[];
  @Prop({ type: String }) agreementType!: string;
  @Prop({ type: Boolean, default: false }) stopScroll!: boolean;
  @Prop({ type: Boolean, default: true }) defaultAgreement!: boolean;
  @Prop({ type: Boolean, default: true }) defaultSelectStatus!: boolean;
  @Prop({ default: true }) canShowAgreeBomBar!: boolean;

  scoller: SmoothScroll | null = null;
  isShowModal = false;
  renderItem = {};
  get isShowBottomTip() {
    return this.canShowAgreeBomBar && (this.bottomTip || this.isShowAgreeTip);
  }
  mounted() {
    const ele = document.getElementById('t-scroll-container');
    if (ele) {
      this.scoller = new SmoothScroll(ele);
    }
  }
  handleAgreementChange(isAgree: boolean) {
    this.isShowAgreeTip = !isAgree;
    this.$emit('agree-change', isAgree);
    // if (this.defaultAgreement) {
    //   this.$nextTick(() => {
    //     this.scoller && this.scoller.scrollToBottom(100);
    //   });
    // }
  }
  handleShowAgreement(res: any) {
    this.renderItem = res;
    this.isShowModal = true;
    this.$emit('showAgreement', res);
  }
  handleInitAgreements(res: any) {
    this.$emit('initAgreements', res);
  }
}
</script>

<style lang="scss" scoped>
.agreement-text {
  z-index: 1;
  margin-top: -102px;
  transform: translateZ(0);
  &.no-default-agree {
    display: none;
  }
}
.agree {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box; // 注意
  height: 32px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  color: #ffffff;
  font-weight: 500;
  font-size: 20px;
  background-color: #fa6a6a;
}
</style>
